import { ButtonStyled } from './Buttons.styled';
import { TextStyled } from './Text.styled';

import { css, CSSObject } from '@emotion/react';

import styled from '@emotion/styled';
import { mq } from '@hangar31/rc-layout';

import toColor from '@OnArk/utils/toColor';

export const BoxStyled = styled.div<{ selected?: number }>(
  ({ theme }) => ({
    h1: theme.font('sm', 'bl'),
    overflow: 'auto',
  }),
  ({ theme }) => theme.effects.box,
  ({ theme }) => css`
    padding: 2rem;
    > h1 {
      &:first-of-type {
        display: flex;
        margin-top: 0;
        small {
          margin-left: auto;

          font-weight: normal;
        }
      }

      color: ${theme.colors.grayDark};
      text-transform: uppercase;
    }
  `
);

export const GoBoxStyled = styled.div(
  ({ theme }) =>
    mq({
      h1: [theme.font('xs', 'md'), , , theme.font('sm', 'md')],
      p: [theme.font('xs'), , , theme.font('sm')],
    }),
  ({ theme }) => css`
    position: relative;

    background: ${theme.colors.whiteDark};

    border: 1px solid ${theme.colors.border};
    border-radius: ${theme.radius.md};

    &:before {
      position: absolute;
      top: -0.1rem;
      bottom: -0.1rem;
      left: -0.1rem;

      background-color: ${toColor(theme.church.bannerColor)};
      border-radius: ${theme.radius.md} 0 0 ${theme.radius.md};
      content: '';
    }

    h1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;

      line-height: 1em;
      text-transform: uppercase;
      span {
        margin-right: 1rem;
      }
      ${ButtonStyled} {
        min-width: 8rem;
        margin: 1.5rem 0 1.5rem auto;

        box-shadow: none;
      }
    }
    > ${TextStyled} {
      min-height: 0 !important;
      margin: 0;
      padding: 1.6rem 1.6rem 1.6rem 3rem !important;

      line-height: 1.14;

      background-color: ${theme.colors.white};
      border-top: 1px solid ${theme.colors.border};
      border-radius: 0 0 ${theme.radius.md} ${theme.radius.md};
    }

    a {
      transition: all 0.2s;
      + i {
        margin-right: 0.8rem;

        transition: all 0.2s;
      }
      &:hover {
        + i {
          margin-right: -0rem;
          margin-left: 0.8rem;
        }
      }
    }
  `,
  mq({
    ':before': { width: ['1rem', , , '1.5rem'] },
    a: {
      ' + i': { display: ['none', , , 'inline-block'] },
      fontSize: ['1.2rem', , , '1.4rem'],
      margin: ['1rem 0 1rem auto', , , '1.5rem 0 1.5rem auto'],
      padding: ['0.5rem 2rem', , , '0.9rem 2.7rem'],
    },
    h1: { marginLeft: ['2rem', , , '3rem'] },
  })
);

export const ExpandableStyled = styled.article<{ open?: boolean }>(
  () => css`
    overflow: hidden;

    p {
      padding: 1rem;
      overflow: hidden;

      transition: all 0.2s;
    }
  `,
  ({ open }): CSSObject => ({
    i: { transform: `rotate(${open ? '-180deg' : '0deg'})` },
    p: {
      maxHeight: open ? '10rem' : '0',
      paddingBottom: open ? 'inherit' : '0',
      paddingTop: open ? 'inherit' : '0',
    } as CSSObject,
  })
);

export const TeamMemberStyled = styled.div<{
  locked?: boolean;
  disabled?: boolean;
}>(
  ({ theme }) => theme.font('sm'),
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding: 2rem;
    row-gap: 2rem;

    background: ${theme.colors.white};

    border-radius: ${theme.radius.md};
    cursor: pointer;
    p {
      width: max-content;
      max-width: calc(100% - 4rem);
      margin: 0;
    }
    small {
      color: ${theme.colors.grayMed};
    }
    > i {
      align-self: flex-start;

      color: ${theme.colors.clickable};
    }
  `,

  ({ disabled, theme }) =>
    disabled &&
    css`
      background: ${theme.colors.disabled};
    `
);
